<template>
  <div>
    <el-row class="panel-main">
      <el-col class="panel-left">
        <div class="panel-title">
          <el-button type="text" icon="el-icon-arrow-left" @click="onBack">返回</el-button>
        </div>
        <div class="panel-content cs-fullHeight">
          <el-row>
            <el-col :span="20">
              <h4>{{ dataModel.phone }}</h4>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20">
              <span v-if="!dataModel.isAuId" class="cs-color-green">速成新生</span>
              <el-button class="edit-button" size="medium" type="text" @click="onShowMemberInfo">{{ showMemberInfoBtnText }}</el-button>
            </el-col>
          </el-row>
          <el-row v-show="isMemberInfoVisible">
            <el-col :span="20">
              <member-info :options="optionsForComponents.memberInfo" :data-in="dataForComponents.memberInfo"></member-info>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20">&nbsp;</el-col>
          </el-row>
          <el-row>
            <el-col :span="20">
              <ocf-workflow-card :options="optionsForComponents.ocfWorkflowCard" :data="dataForComponents.ocfWorkflowCard"></ocf-workflow-card>
            </el-col>
          </el-row>
        </div>
      </el-col>
      <el-col class="panel-right">
        <div class="panel-title backgroud-gray-popup">
          <h4>收费信息</h4>
        </div>
        <div class="panel-content cs-fullHeight">
          <el-row>
            <el-col :span="20">
              <el-row v-show="dataModel.type == this.GLOBAL.otherCollectFeeType.bonusPointExchangeItem.value">
                <el-col :span="12">
                  <span>兑换物品: </span>
                </el-col>
                <el-col :span="12" class="align-right">
                  <span>{{ bpeItemName }}</span>
                </el-col>
              </el-row>
              <el-row v-show="dataModel.type == this.GLOBAL.otherCollectFeeType.academicPlanning.value">
                <el-col :span="12">
                  <span>学业规划类型: </span>
                </el-col>
                <el-col :span="12" class="align-right">
                  <span>{{ ocfSubTypeDescription }}</span>
                </el-col>
              </el-row>
              <div v-if="dataModel.type == this.GLOBAL.otherCollectFeeType.topUpBalance.value">
                <el-row>
                  <el-col :span="12">
                    <span>余额充值优惠：</span>
                  </el-col>
                  <el-col :span="12" class="align-right">
                    <span>{{ getGiftBalanceItemText() }}</span>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <span>充值金额：</span>
                  </el-col>
                  <el-col :span="12" class="align-right">
                    <span>{{ dataModel.amount | toCurrency }}</span>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <span>赠送金额：</span>
                  </el-col>
                  <el-col :span="12" class="align-right">
                    <span v-if="dataModel.giftAmount != null">{{ dataModel.giftAmount | toCurrency }}</span>
                    <span v-else>{{ 0 | toCurrency }}</span>
                  </el-col>
                </el-row>
              </div>
              <el-row v-if="dataModel.type != this.GLOBAL.otherCollectFeeType.topUpBalance.value">
                <el-col :span="12">
                  <span>价格: </span>
                </el-col>
                <el-col :span="12" class="align-right">
                  <span>{{ dataModel.amount | toCurrency }}</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <span>数量: </span>
                </el-col>
                <el-col :span="12" class="align-right">
                  <span>{{ dataModel.quantity }}</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <span>总价: </span>
                </el-col>
                <el-col :span="12" class="align-right">
                  <span>{{ dataModel.totalPrice | toCurrency }}</span>
                </el-col>
              </el-row>
              <!-- <el-row v-show="!!dataModel.balanceCost" class="cs-redLabel">
                <el-col :span="12">
                  <span>使用余额: </span>
                </el-col>
                <el-col :span="12" class="align-right">
                  <span>{{ (-1 * dataModel.balanceCost) | toCurrency }}</span>
                </el-col>
              </el-row> -->
              <el-row v-if="!!newBalanceCostTotal" class="cs-redLabel">
                <el-col :span="12">
                  <span>使用新余额: </span>
                </el-col>
                <el-col :span="12" class="align-right">
                  <span>{{(-1 * newBalanceCostTotal) | toCurrency}}</span>
                </el-col>
              </el-row>
              <el-row v-if="!!giftBalanceCostTotal" class="cs-redLabel">
                <el-col :span="12">
                  <span>使用赠送余额: </span>
                </el-col>
                <el-col :span="12" class="align-right">
                  <span>{{(-1 * giftBalanceCostTotal) | toCurrency}}</span>
                </el-col>
              </el-row>
              <el-row v-if="!!oldBalanceCostTotal" class="cs-redLabel">
                <el-col :span="12">
                  <span>使用旧余额: </span>
                </el-col>
                <el-col :span="12" class="align-right">
                  <span>{{(-1 * oldBalanceCostTotal) | toCurrency}}</span>
                </el-col>
              </el-row>
              <el-row v-show="!!dataModel.bonusPointPrice" class="cs-redLabel">
                <el-col :span="12">
                  <span>使用积分: </span>
                </el-col>
                <el-col :span="12" class="align-right">
                  <span>{{ (-1 * dataModel.bonusPointPrice) | toCurrency }}</span>
                </el-col>
              </el-row>
              <el-row v-show="!!dataModel.cashDecreasedAmount" class="cs-redLabel">
                <el-col :span="12">
                  <span>使用现金减: </span>
                </el-col>
                <el-col :span="12" class="align-right">
                  <span>{{ (-1 * dataModel.cashDecreasedAmount) | toCurrency }}</span>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <hr>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20">
              <account-info :options="optionsForComponents.accountInfo" :data="dataForComponents.accountInfo"></account-info>
            </el-col>
          </el-row>
          <!-- <el-row>
            <el-col>
              <hr>
            </el-col>
          </el-row> -->
          <el-row class="section-title">
            <el-col>
              <span>支付详情: </span>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <payment-list-view ref="payment-list-view" :data-list="dataModel.accountPayments" :options="optionsForComponents.paymentListView"
                @item-click="onPaymentListViewItemClick" @item-remove="onPaymentListViewItemRemove"></payment-list-view>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20">
              <el-row v-if="!!dataForComponents.accountInfo.excessAmount">
                <el-col :span="14">
                  <span>超出金额: </span>
                </el-col>
                <el-col :span="10" class="align-right">
                  <span>{{dataForComponents.accountInfo.excessAmount | toCurrency}}</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="14">
                  <span>待付款(除手续费): </span>
                </el-col>
                <el-col :span="10" class="align-right">
                  <span>{{dataForComponents.accountInfo.debt | toCurrency}}</span>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <hr>
            </el-col>
          </el-row>
          <!-- <el-row>
            <el-col>
              <span>付款备注: </span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20">
              <el-input type="textarea" :rows="4" resize="none" v-model="paymentComments" :disabled="true"></el-input>
            </el-col>
          </el-row> -->
          <el-row>
            <el-col>
              <span>账目备注: </span>
              <el-button v-if="optionsForComponents.paymentListView.enableEdit" class="edit-button" size="medium margin-left-10" type="text"
                @click="onEidtAccountCommentClick()">编辑备注</el-button>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20">
              <el-input type="textarea" :rows="4" resize="none" v-model="accountModel.Comment" :disabled="true"></el-input>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
    <el-dialog :center="true" :close-on-click-modal="false" width="600px" :visible.sync="paymentEditorVisible" top="3vh">
      <payment-editor ref="payment-editor" :account-id="accountId" :data="dataForComponents.paymentEditor" :options="optionsForComponents.paymentEditor"
        :conditions="conditionsForComponents.paymentEditor" @closeDialog="onPaymentEditorClose" @callback="onPaymentEditorCallback"></payment-editor>
    </el-dialog>

    <el-dialog :center="true" :close-on-click-modal="false" width="600px" :visible.sync="paymentCommentEditorVisible" top="5vh">
      <paymentCommentEditor :dataIn="dataForComponents.paymentCommentEditor" @success="onPaymentCommentEditorSuccess" />
    </el-dialog>

    <el-dialog :center="true" :close-on-click-modal="false" width="600px" :visible.sync="accountCommentEditorVisible" top="5vh">
      <accountCommentEditor :dataIn="dataForComponents.accountCommentEditor" @success="onAccountCommentEditorSuccess" />
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
.panel-main {
  display: flex;
}

.panel-left {
  flex: 2;
}

.panel-right {
  flex: 1;
  border-left: 1px solid rgb(227, 227, 227);
}

.panel-title {
  padding: 20px 40px 20px 40px;
  min-height: 81px;
}
</style>

<script>
import navigator from "../../components/navigator";
import memberInfo from "../common/memberInfo_new";
import ocfWorkflowCard from "../../components/addCollectFees/otherCollectFee/ocfWorkflowCard";
import accountInfo from "../../components/finance/accountInfo";
import paymentListView from "../../components/common/paymentListView";
import paymentEditor from "../../components/common/paymentEditor";

import { getBonusPointExchangeItemList } from "../../service/bonusPoint.service";
import { getStudentMemberInfo } from "../../service/student.service";
import { saveAccount } from "../../service/finance.service";
import { getContractList } from "@/service/contract.service";
import {
  createWorkflowModel,
  getWorkflowDataByAccountId,
  getGiftBalances,
} from "../../service/otherCollectFee.service";

export default {
  props: {
    data: {
      account: Object,
    },
  },
  data() {
    return {
      isMemberInfoVisible: false,
      showMemberInfoBtnText: "查看完整信息",
      accountId: 0,
      dataChanged: false,
      bonusPointExchangeItems: [],
      otherCollectFeeTypes: [],
      giftBalanceList: [],
      wfModel: null,
      studentModel: null,
      accountModel: {},
      dataModel: {
        phone: null,
        studentId: 0,
        isAuId: false,
        type: 0,
        subType: null,
        amount: 0,
        quantity: 0,
        totalPrice: 0,
        oldBalanceCost: 0,
        newBalanceCost: 0,
        giftBalanceCost: 0,
        balanceCost: 0,
        bonusPointPrice: 0,
        cashDecreasedAmount: 0,
        bpeItemId: null,
        accountPayments: [],
        giftBalanceId: null,
        giftAmount: null,
        courseId: null,
      },
      optionsForComponents: {
        memberInfo: {
          showTitle: false,
          showPhone: false,
          enableEdit: false,
          enableBuymember: false,
          showIsNew: false,
          enableRegister: false,
        },
        ocfWorkflowCard: {
          enableEdit: false,
        },
        accountInfo: {
          displayType: "simple2",
        },
        paymentListView: {
          displayType: "simple",
          enableEdit: true,
          enableRemove: false,
        },
        paymentEditor: {
          showTitle: true,
          allowPaidCount: 0,
        },
      },
      dataForComponents: {
        memberInfo: {
          memberModel: null,
        },
        ocfWorkflowCard: {
          bonusPointExchangeItems: [],
          otherCollectFeeTypes: [],
          giftBalanceList: [],
          ocfType: 0,
          subType: null,
          studentId: 0,
          phone: null,
          comment: null,
          amount: 0,
          quantity: 0,
          totalPrice: 0,
          bonusPointCost: 0,
          bpeItemId: null,
          giftBalanceId: null,
          giftAmount: null,
          courseId: null,
        },
        accountInfo: {
          amount: 0,
          paidAmount: 0,
          excessAmount: 0,
          debt: 0,
        },
        paymentEditor: {
          index: -1,
          item: null,
        },
        paymentCommentEditor: {
          accountPaymentId: 0,
          comment: "",
        },
        accountCommentEditor: {
          accountId: 0,
          comment: "",
        },
      },
      conditionsForComponents: {
        paymentEditor: {
          paidCount: 0,
          paymentAmount: 0,
        },
      },
      paymentEditorVisible: false,
      editIndex: -1,
      editPayment: null,
      paymentCommentEditorVisible: false,
      accountCommentEditorVisible: false,
    };
  },
  components: {
    navigator,
    memberInfo,
    ocfWorkflowCard,
    accountInfo,
    paymentListView,
    paymentEditor,
    paymentCommentEditor: () =>
      import("@/components/finance/paymentCommentEditor"),
    accountCommentEditor: () =>
      import("@/components/finance/accountCommentEditor"),
  },
  computed: {
    bpeItemName: function () {
      let bpeItem = this.__findBonusPointExchangeItem(this.dataModel.bpeItemId);
      return !!bpeItem ? bpeItem.ItemName : null;
    },
    ocfSubTypeDescription: function () {
      if (!this.dataModel.subType) return null;

      let result = null;
      switch (this.dataModel.subType) {
        case 1:
          result = "单次";
          break;
        case 2:
          result = "无限次";
          break;
      }

      return result;
    },
    paidAmount: function () {
      let result = this.__getPaidAmount();

      return result;
    },
    excessAmount: function () {
      if (!this.accountModel || this.paidAmount <= this.accountModel.Amount)
        return 0;

      return this.paidAmount - this.accountModel.Amount;
    },
    paymentComments: function () {
      let comments = "";
      if (!!this.wfModel && !!this.wfModel.Comment) {
        comments = this.wfModel.Comment;
      }
      if (
        !this.accountModel ||
        !this.accountModel.AccountPayments ||
        this.accountModel.AccountPayments.length == 0
      )
        return comments;

      let result = "";
      for (let i = 0; i < this.accountModel.AccountPayments.length; i++) {
        let payment = this.accountModel.AccountPayments[i];
        if (!payment.Enable || !payment.Comment) continue;
        result += `${payment.Comment}\r\n`;
      }

      if (!!comments) comments += "\r\n";
      if (!!result) {
        comments += result;
      }

      return comments;
    },
    giftBalanceCostTotal() {
      return this.dataModel.giftBalanceCost;
    },
    oldBalanceCostTotal() {
      return this.dataModel.oldBalanceCost;
    },
    newBalanceCostTotal() {
      return this.dataModel.newBalanceCost;
    },
  },
  created() {
    this.init();
  },
  methods: {
    async loadGiftBalances() {
      let result = await getGiftBalances();
      if (!!result && result.success) {
        this.giftBalanceList = result.data;
      } else {
        this.giftBalanceList = [];
      }
    },
    async loadBonusPointExchangeItemsFromServer() {
      let result = await getBonusPointExchangeItemList();
      if (!!result && result.success) {
        this.bonusPointExchangeItems = result.data;
      } else {
        this.bonusPointExchangeItems = [];
      }
    },
    async loadWorkflowDataFromServer() {
      if (!this.accountId) {
        this.wfModel = null;
        return;
      }

      let result = await getWorkflowDataByAccountId(this.accountId);
      if (!!result && result.success) this.wfModel = result.data;
      else this.wfModel = null;
    },
    async loadStudentMemberInfoFromServer(
      studentId = this.dataModel.studentId
    ) {
      if (!studentId) {
        this.studentModel = null;
        return;
      }

      let result = await getStudentMemberInfo(studentId);
      if (!!result && result.success) this.studentModel = result.data;
      else this.studentModel = null;
    },
    loadAccountDataFromProps(account = this.data.account) {
      if (!!account) {
        this.accountId = account.Id;
        this.accountModel = account;
      } else {
        this.accountId = 0;
        this.accountModel = null;
      }
    },
    loadOtherCollectFeeTypesFromGlobal() {
      let newTypes = [];
      for (let fieldName in this.GLOBAL.otherCollectFeeType) {
        let field = this.GLOBAL.otherCollectFeeType[fieldName];
        newTypes.push({
          name: fieldName,
          value: field.value,
          description: field.description,
          needStudent: field.needStudent,
        });
      }
      this.otherCollectFeeTypes = newTypes;
    },
    async saveAccountDataToServer(saveData) {
      if (!saveData) return false;

      let result = await saveAccount(saveData);

      return !!result && result.success;
    },
    async init() {
      await this.loadGiftBalances();
      await this.loadBonusPointExchangeItemsFromServer();
      this.loadOtherCollectFeeTypesFromGlobal();
      await this.reloadAllDataModel();
    },
    async reloadAllDataModel(account = this.data.account) {
      this.isMemberInfoVisible = false;
      this.showMemberInfoBtnText = "查看完整信息";
      this.loadAccountDataFromProps(account);
      await this.loadWorkflowDataFromServer();
      let studentId = !!this.wfModel ? this.wfModel.StudentId : 0;
      await this.loadStudentMemberInfoFromServer(studentId);
      this.reloadDataModel();
      this.reloadDataForMemberInfo();
      this.reloadDataForOCFWorkflowCard();
      this.reloadDataForAccountInfo();
    },
    reloadDataModel() {
      if (!!this.wfModel) {
        this.dataModel.phone = this.wfModel.Phone;
        this.dataModel.studentId = this.wfModel.StudentId;
        this.dataModel.type = this.wfModel.Type;
        this.dataModel.subType = this.wfModel.SubType;
        this.dataModel.amount = this.wfModel.Amount;
        this.dataModel.quantity = this.wfModel.Quantity;
        this.dataModel.totalPrice = this.wfModel.TotalPrice;
        this.dataModel.oldBalanceCost = this.wfModel.OldBalanceCost;
        this.dataModel.newBalanceCost = this.wfModel.NewBalanceCost;
        this.dataModel.giftBalanceCost = this.wfModel.GiftBalanceCost;
        this.dataModel.balanceCost = this.wfModel.BalanceCost;
        this.dataModel.bonusPointPrice = this.wfModel.BonusPointPrice;
        this.dataModel.bpeItemId = this.wfModel.BonusPointExchangeItemId;
        this.dataModel.cashDecreasedAmount = this.wfModel.CashDecreasedAmount;
        this.dataModel.giftBalanceId = this.wfModel.GiftBalanceId;
        this.dataModel.giftAmount = this.wfModel.GiftAmount;
        this.dataModel.courseId = this.wfModel.CourseId;
      } else {
        this.dataModel.phone = null;
        this.dataModel.studentId = 0;
        this.dataModel.type = 0;
        this.dataModel.subType = null;
        this.dataModel.amount = 0;
        this.dataModel.quantity = 0;
        this.dataModel.totalPrice = 0;
        this.dataModel.oldBalanceCost = 0;
        this.dataModel.newBalanceCost = 0;
        this.dataModel.giftBalanceCost = 0;
        this.dataModel.balanceCost = 0;
        this.dataModel.bonusPointPrice = 0;
        this.dataModel.cashDecreasedAmount = 0;
        this.dataModel.bpeItemId = null;
        this.dataModel.giftBalanceId = null;
        this.dataModel.giftAmount = 0;
        this.dataModel.courseId = null;
      }

      if (!!this.studentModel) {
        this.dataModel.isAuId = this.studentModel.IsAuId;
      } else {
        this.dataModel.isAuId = false;
      }

      if (!!this.accountModel) {
        this.dataModel.accountPayments = $.extend(
          true,
          [],
          this.accountModel.AccountPayments
        );
      } else {
        this.dataModel.accountPayments = [];
      }
    },
    reloadDataForMemberInfo() {
      let newData = {
        memberModel: null,
      };

      newData.memberModel = this.studentModel;

      this.dataForComponents.memberInfo = newData;
    },
    reloadDataForOCFWorkflowCard() {
      let newData = {
        bonusPointExchangeItems: [],
        otherCollectFeeTypes: [],
        giftBalanceList: [],
        ocfType: 0,
        subType: null,
        studentId: 0,
        phone: null,
        comment: null,
        amount: 0,
        quantity: 0,
        totalPrice: 0,
        bonusPointCost: 0,
        bpeItemId: null,
        giftBalanceId: null,
        giftAmount: null,
        courseId: null,
      };

      newData.bonusPointExchangeItems = this.bonusPointExchangeItems;
      newData.otherCollectFeeTypes = this.otherCollectFeeTypes;
      newData.giftBalanceList = this.giftBalanceList;

      if (!!this.wfModel) {
        newData.ocfType = this.wfModel.Type;
        newData.subType = this.wfModel.SubType;
        newData.studentId = this.wfModel.StudentId;
        newData.phone = this.wfModel.Phone;
        newData.comment = this.wfModel.Comment;
        newData.amount = this.wfModel.Amount;
        newData.quantity = this.wfModel.Quantity;
        newData.totalPrice = this.wfModel.TotalPrice;
        newData.bonusPointCost = this.wfModel.BonusPointCost;
        newData.bpeItemId = this.wfModel.BonusPointExchangeItemId;
        newData.giftBalanceId = this.wfModel.GiftBalanceId;
        newData.giftAmount = this.wfModel.GiftAmount;
        newData.courseId = this.wfModel.CourseId;
      }

      this.dataForComponents.ocfWorkflowCard = newData;
    },
    reloadDataForAccountInfo() {
      let newData = {
        amount: 0,
        paidAmount: 0,
        excessAmount: 0,
        debt: 0,
      };

      if (!!this.accountModel) {
        newData.amount = this.accountModel.Amount;
        newData.paidAmount = this.paidAmount;
        newData.excessAmount = this.excessAmount;
        newData.debt = this.accountModel.Debt;
      }

      this.dataForComponents.accountInfo = newData;
    },
    reloadDataForPaymentEditor() {
      let newData = {
        index: -1,
        item: null,
      };

      newData.index = this.editIndex;
      newData.item = this.editPayment;

      this.dataForComponents.paymentEditor = newData;
    },
    async onBack() {
      let isReload = this.dataChanged;
      this.$emit("close", isReload);
      this.dataChanged = false;
    },
    onShowMemberInfo() {
      this.isMemberInfoVisible = !this.isMemberInfoVisible;
      this.showMemberInfoBtnText = this.isMemberInfoVisible
        ? "隐藏完整信息"
        : "查看完整信息";
    },
    onPaymentListViewItemClick(dataOut) {
      if (dataOut.isEditComment) {
        this.openPaymentCommentEditor(dataOut.item);
      } else {
        this.editIndex = dataOut.index;
        this.editPayment = dataOut.item;
        this.reloadDataForPaymentEditor();

        this.paymentEditorVisible = true;
      }
    },
    async onPaymentListViewItemRemove(dataOut) {
      let confirmResult = false;
      await this.$confirm("是否删除该项支付?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          confirmResult = true;
        })
        .catch(() => {});
      if (!confirmResult) return;

      let saveData = this.__getSaveModel();
      let payment =
        dataOut.index >= 0 ? saveData.AccountPayments[dataOut.index] : null;
      if (!payment) return;

      payment.Enable = false;

      let result = await this.saveAccountDataToServer(saveData);
      this.$message({
        message: `删除${result ? "成功" : "失败"}`,
        type: result ? "success" : "error",
      });
      if (!result) return;

      this.loadAccountDataFromProps(saveData);
      this.reloadDataModel();
      this.reloadDataForAccountInfo();
      this.dataChanged = true;
    },
    onPaymentEditorClose() {
      this.paymentEditorVisible = false;
      this.editIndex = -1;
      this.editPayment = null;
      this.reloadDataForPaymentEditor();
    },
    async onPaymentEditorCallback(dataOut) {
      let saveData = this.__getSaveModel();
      let payment =
        dataOut.index >= 0 ? saveData.AccountPayments[dataOut.index] : null;
      if (!payment) return;

      payment.PaymentTypeId = dataOut.data.PaymentTypeId;
      payment.ServiceCharge = dataOut.data.ServiceCharge;
      payment.Amount = dataOut.data.Amount;
      payment.Comment = dataOut.data.Comment;

      let paidAmount = this.__getPaidAmount(saveData);
      saveData.Debt =
        saveData.Amount > paidAmount ? saveData.Amount - paidAmount : 0;

      let result = await this.saveAccountDataToServer(saveData);
      this.$message({
        message: `保存${result ? "成功" : "失败"}`,
        type: result ? "success" : "error",
      });
      if (!result) return;

      this.loadAccountDataFromProps(saveData);
      this.reloadDataModel();
      this.reloadDataForAccountInfo();
      this.dataChanged = true;
    },
    __findBonusPointExchangeItem(id) {
      let result = null;
      for (let i = 0; i < this.bonusPointExchangeItems.length; i++) {
        let item = this.bonusPointExchangeItems[i];
        if (item.Id == id) {
          result = item;
          break;
        }
      }
      return result;
    },
    __getSaveModel() {
      let saveModel = $.extend(true, {}, this.accountModel);

      return saveModel;
    },
    __getPaidAmount(account = this.accountModel) {
      if (
        !account ||
        !account.AccountPayments ||
        account.AccountPayments.length == 0
      )
        return 0;

      let result = 0;
      for (let i = 0; i < account.AccountPayments.length; i++) {
        let payment = account.AccountPayments[i];
        if (!payment.Enable) continue;
        result += payment.Amount;
      }
      return result;
    },
    __findGiftBalanceItem() {
      return this.giftBalanceList.find(
        (i) => i.Id == this.dataModel.giftBalanceId
      );
    },
    getGiftBalanceItemText() {
      let item = this.__findGiftBalanceItem();
      if (!!item) {
        return item.FullName;
      }
      return "";
    },

    openPaymentCommentEditor(data) {
      this.dataForComponents.paymentCommentEditor = {
        accountPaymentId: data.Id,
        comment: data.Comment,
      };

      this.paymentCommentEditorVisible = true;
    },
    async onPaymentCommentEditorSuccess(data) {
      this.$message({
        message: `保存备注成功`,
        type: "success",
      });

      let payment = this.accountModel.AccountPayments.find(
        (i) => i.Id === data.accountPaymentId
      );
      payment.Comment = data.comment;
      this.dataModel.accountPayments = $.extend(
        true,
        [],
        this.accountModel.AccountPayments
      );
      this.paymentCommentEditorVisible = false;
      this.dataChanged = true;
    },

    openAccountCommentEditor() {
      this.dataForComponents.accountCommentEditor = {
        accountId: this.accountModel.Id,
        comment: this.accountModel.Comment,
      };

      this.accountCommentEditorVisible = true;
    },
    async onAccountCommentEditorSuccess(data) {
      this.$message({
        message: `保存账目备注成功`,
        type: "success",
      });
      this.accountModel.Comment = data.comment;
      this.accountCommentEditorVisible = false;
      this.dataChanged = true;
    },
    onEidtAccountCommentClick() {
      this.openAccountCommentEditor();
    },
  },
  watch: {
    data: function (newVal) {
      this.reloadAllDataModel(newVal.account);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/finance/ocfAccountProfile.vue